// Brand assets & content for La Herencia Castañón

export const LOGO_URL =
  "https://customer-assets-lqy194kg.emergentagent.net/job_herencia-castanon/artifacts/2tg29vo6_4ffba040-f083-4cdf-b32e-64c836cd652f.jpg";

export const HERO_URL =
  "https://customer-assets.emergentagent.com/job_1c12cdd3-9253-4188-974f-02d9c6ee9f1d/artifacts/5svs5qxi_Hero%20La%20Herencia%20Casta%C3%B1on%20%28Hero%29.jpg";

export const CONTACT = {
  phoneDisplay: "+52 614 467 7564",
  phoneTel: "+526144677564",
  whatsapp: "526144677564",
  address: "C. Tabasco 44, La Junta, 31304 Chihuahua",
  mapsQuery: "C. Tabasco 44, La Junta, 31304 Chihuahua, México",
};

export const WHATSAPP_MSG = encodeURIComponent(
  "¡Hola La Herencia Castañón! Me gustaría hacer un pedido de barbacoa. 🌮",
);

export const WHATSAPP_LINK = `https://wa.me/${CONTACT.whatsapp}?text=${WHATSAPP_MSG}`;
export const CALL_LINK = `tel:${CONTACT.phoneTel}`;

// Pedidos en línea -> WhatsApp del negocio (+52 614 467 7564)
export const ORDER_WHATSAPP_NUMBER = "526144677564";

export const SALSAS = ["Árbol", "Serrano", "Habanero"];

export const GRANEL_EXTRAS = [
  { name: "Pieza de pan", price: 12 },
  { name: "Paquete de tortillas", price: 12 },
  { name: "Verdura extra", price: 15 },
  { name: "Salsa extra", price: 5 },
];

// Formato uniforme de precios: "$150 MXN"
export const money = (n) => `$${n} MXN`;

// Preparación independiente de la salsa
export const PREPARACIONES = ["Natural", "Chipotle", "Mixto"];

// Redes sociales oficiales
export const SOCIAL = {
  facebook: "https://www.facebook.com/share/19U7zwnA4Y/",
  instagram: "https://www.instagram.com/barbacoa.hc?igsh=aHVxOTJkYndpenAz",
};

// Google Maps (mismo destino que el mapa embebido)
export const MAPS_SEARCH_URL = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
  CONTACT.mapsQuery,
)}`;
export const MAPS_DIRECTIONS_URL = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
  CONTACT.mapsQuery,
)}`;

// Pedido mínimo a domicilio por distancia (sin costo de envío)
export const DELIVERY_TIERS = [
  { id: "0-2", label: "0 – 2 km", min: 100 },
  { id: "2-4", label: "2 – 4 km", min: 200 },
  { id: "4-6", label: "4 – 6 km", min: 300 },
  { id: "6-8", label: "6 – 8 km", min: 400 },
  { id: "8-10", label: "8 – 10 km", min: 500 },
  { id: "10+", label: "Más de 10 km", min: null },
];

// Destacados para el carrusel
export const HIGHLIGHTS = [
  { icon: "truck", title: "Servicio a domicilio", text: "Llevamos la barbacoa hasta tu puerta, sin costo de envío.", href: "#menu" },
  { icon: "bike", title: "DiDi Food, Rappi y Uber Eats", text: "También nos encuentras en tus apps de entrega favoritas.", href: "#plataformas" },
  { icon: "book", title: "Conoce nuestra historia", text: "Una receta de casa que se volvió tradición.", href: "#nosotros" },
  { icon: "share", title: "Síguenos en redes", text: "Fotos y novedades en Facebook e Instagram.", href: "#redes" },
];

export const SPECIALTIES = [
  {
    name: "Tacos",
    tag: "Los favoritos de la casa",
    desc: "Barbacoa de cachete de res en tortilla de maíz recién hecha, ya sea tradicional o adobada en chipotle, acompañada de verdura y salsa.",
    img: "https://customer-assets-lqy194kg.emergentagent.net/job_herencia-castanon/artifacts/masl0sm3_Tacos.jpg",
  },
  {
    name: "Lonches",
    tag: "Sabor que llena",
    desc: "Pan blanco cocido en horno de leña, relleno de jugosa barbacoa de cachete.",
    img: "https://customer-assets-lqy194kg.emergentagent.net/job_herencia-castanon/artifacts/xdekxdhu_Lonche.jpg",
  },
  {
    name: "Quesibarbacoa",
    tag: "Para los antojados",
    desc: "Tortilla de harina rellena de barbacoa, acompañada de costra de queso Laurel.",
    img: "https://customer-assets-lqy194kg.emergentagent.net/job_herencia-castanon/artifacts/72skqff2_Quesibarbacoa..jpg",
    recommended: true,
  },
  {
    name: "Consomé",
    tag: "Caldo de la olla",
    desc: "Delicioso caldo de la barbacoa acompañado de una porción de barbacoa y garbanzos, el acompañante ideal.",
    img: "https://customer-assets-lqy194kg.emergentagent.net/job_herencia-castanon/artifacts/szi0sjf6_Consome.jpg",
  },
  {
    name: "Chilaquiles",
    tag: "Favorito de la casa",
    desc: "Totopos bañados en cualquiera de nuestras deliciosas salsas, con crema y queso, acompañados de una generosa porción de barbacoa, cebolla curtida y cilantro.",
    img: "https://customer-assets-lqy194kg.emergentagent.net/job_herencia-castanon/artifacts/0s97mljn_Chilaquiles.jpg",
    featured: true,
  },
];

export const MENU = [
  {
    category: "Platillos",
    note: "100% de res · verdura aparte",
    items: [
      { id: "orden-tacos", name: "Orden de tacos (4)", price: 110, type: "individual", prep: true },
      { id: "media-orden", name: "1/2 orden de tacos", price: 55, type: "individual", prep: true },
      { id: "taco", name: "Taco", price: 30, type: "individual", prep: true },
      { id: "lonche", name: "Lonche", price: 110, type: "individual", prep: true },
      { id: "quesibarbacoa", name: "Quesibarbacoa", price: 130, type: "individual", prep: true },
      { id: "chilaquiles", name: "Chilaquiles", price: 160, type: "chilaquiles", prep: true, choiceGroups: [{ id: "salsaChil", title: "Salsa de los chilaquiles", options: ["Verde", "Roja", "Chipotle"] }] },
    ],
  },
  {
    category: "Barbacoa a granel",
    note: "Para compartir · verdura aparte",
    items: [
      { id: "barb-14", name: "1/4 litro de barbacoa", price: 170, type: "granel", prep: true, choiceGroups: [{ id: "acomp", title: "Acompañamiento", options: ["Pan", "Tortillas"] }] },
      { id: "barb-12", name: "1/2 litro de barbacoa", price: 320, type: "granel", prep: true, choiceGroups: [{ id: "acomp", title: "Acompañamiento", options: ["Pan", "Tortillas", "Mixto"] }] },
      { id: "barb-34", name: "3/4 litro de barbacoa", price: 480, type: "granel", prep: true, choiceGroups: [{ id: "acomp", title: "Acompañamiento", options: ["Pan", "Tortillas", "Mixto"] }] },
      { id: "barb-1", name: "Litro de barbacoa", price: 620, type: "granel", prep: true, choiceGroups: [{ id: "acomp", title: "Acompañamiento", options: ["Pan", "Tortillas", "Mixto"] }] },
    ],
  },
  {
    category: "Consomé",
    note: "Caldo de la olla · verdura aparte",
    items: [
      { id: "cons-14", name: "1/4 litro de consomé", price: 35, type: "granel", choiceGroups: [{ id: "prep", title: "Preparación", options: ["Natural", "Chipotle"] }] },
      { id: "cons-12", name: "1/2 litro de consomé", price: 75, type: "granel", choiceGroups: [{ id: "prep", title: "Preparación", options: ["Natural", "Chipotle"] }, { id: "acomp", title: "Acompañamiento", options: ["Pan", "Tortillas"] }] },
      { id: "cons-1", name: "Litro de consomé", price: 130, type: "granel", choiceGroups: [{ id: "prep", title: "Preparación", options: ["Natural", "Chipotle"] }, { id: "acomp", title: "Acompañamiento", options: ["Pan", "Tortillas"] }] },
    ],
  },
  {
    category: "Extras",
    note: "Complementa tu pedido",
    items: [
      { id: "pan", name: "Pieza de pan", price: 12, type: "simple" },
      { id: "tortillas", name: "Paquete de tortillas", price: 12, type: "simple" },
      { id: "verdura", name: "Verdura extra", price: 15, type: "simple" },
      { id: "salsa-extra", name: "Salsa extra", price: 5, type: "simple" },
    ],
  },
  {
    category: "Bebidas",
    note: "Refrescos y aguas frescas",
    items: [
      { id: "ref-355", name: "Refresco de lata 355 ml", price: 30, type: "simple" },
      { id: "ref-600", name: "Refresco 600 ml", price: 30, type: "sabor", choiceGroups: [{ id: "sabor", title: "Sabor", options: ["Coca-Cola Regular", "Coca-Cola Zero", "Coca-Cola Light", "Fanta", "Sprite", "Manzana Soto", "Squirt"] }] },
      { id: "snapple", name: "Snapple Tea", price: 30, type: "sabor", choiceGroups: [{ id: "sabor", title: "Sabor", options: ["Limón", "Durazno", "Frambuesa"] }] },
      { id: "rootbeer", name: "Root Beer A&W 355 ml", price: 30, type: "simple" },
      { id: "jugo-naranja", name: "Jugo de naranja natural 500 ml", price: 35, type: "simple" },
      { id: "agua", name: "Agua natural", price: 15, type: "simple" },
      { id: "agua-500", name: "Agua de sabor 500 ml", price: 30, type: "sabor", choiceGroups: [{ id: "sabor", title: "Sabor", options: ["Limón", "Jamaica", "Horchata"] }] },
      { id: "agua-1l", name: "Agua de sabor 1 litro", price: 45, type: "sabor", choiceGroups: [{ id: "sabor", title: "Sabor", options: ["Limón", "Jamaica", "Horchata"] }] },
    ],
  },
];

export const HOURS = [
  { day: "Lunes", key: "Mon", time: "8:00 a.m. – 1:00 p.m.", o: 480, c: 780 },
  { day: "Martes", key: "Tue", time: "Cerrado", closed: true },
  { day: "Miércoles", key: "Wed", time: "Cerrado", closed: true },
  { day: "Jueves", key: "Thu", time: "7:00 a.m. – 2:00 p.m.", o: 420, c: 840 },
  { day: "Viernes", key: "Fri", time: "7:00 a.m. – 2:00 p.m.", o: 420, c: 840 },
  { day: "Sábado", key: "Sat", time: "7:00 a.m. – 2:00 p.m.", o: 420, c: 840 },
  { day: "Domingo", key: "Sun", time: "7:00 a.m. – 2:00 p.m.", o: 420, c: 840 },
];

// Enlaces directos a las plataformas de entrega (DiDi pendiente)
export const DELIVERY_LINKS = {
  didi: null,
  rappi:
    "https://www.rappi.com.mx/restaurantes/delivery/693444-barbacoa-la-herencia-castanon?utm_source=app&utm_medium=deeplink&utm_campaign=share",
  uber:
    "https://www.ubereats.com/store-browse-uuid/4fe6f2cd-6aa9-5679-a4ce-48e5a4bb498c?diningMode=DELIVERY",
};

export const GALLERY = [
  {
    url: "https://customer-assets-lqy194kg.emergentagent.net/job_herencia-castanon/artifacts/masl0sm3_Tacos.jpg",
    alt: "Orden de tacos de barbacoa",
    span: "md:col-span-2 md:row-span-2",
  },
  {
    url: "https://customer-assets-lqy194kg.emergentagent.net/job_herencia-castanon/artifacts/72skqff2_Quesibarbacoa..jpg",
    alt: "Quesibarbacoa dorada",
    span: "",
  },
  {
    url: "https://customer-assets-lqy194kg.emergentagent.net/job_herencia-castanon/artifacts/szi0sjf6_Consome.jpg",
    alt: "Consomé de barbacoa",
    span: "",
  },
  {
    url: "https://customer-assets-lqy194kg.emergentagent.net/job_herencia-castanon/artifacts/0s97mljn_Chilaquiles.jpg",
    alt: "Chilaquiles con barbacoa",
    span: "",
  },
  {
    url: "https://customer-assets-lqy194kg.emergentagent.net/job_herencia-castanon/artifacts/xdekxdhu_Lonche.jpg",
    alt: "Lonche de barbacoa",
    span: "",
  },
  {
    url: "https://customer-assets-lqy194kg.emergentagent.net/job_herencia-castanon/artifacts/masl0sm3_Tacos.jpg",
    alt: "Tacos de barbacoa recién servidos",
    span: "md:col-span-2",
  },
];
